export const injectCustomStyle = (css?: string | null) => {
  if (!css || document.getElementById('portal-custom-styles')) return;

  const styleElement = document.createElement('style');
  styleElement.id = 'portal-custom-styles';
  styleElement.innerHTML = css;

  document.head.append(styleElement);
};
